import {
  Button,
  Flex,
  Icon,
  InputItem,
  List,
  NavBar,
  Picker,
  SegmentedControl,
  Toast,
} from "antd-mobile";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { bottomBtnStyle } from "..";
import instance from "../../../../util/axios";
import { formatRoundNumber } from "../util";
import StepSix, { OrderCollection } from "./StepSix";

interface AdvisorSplit {
  advisorId: string[];
  scale: string;
  editable: boolean;
}
export interface OrderSplit {
  advisorType: string;
  splitData: AdvisorSplit[];
}
interface sevenProps {
  onCancel?: () => void;
  onOk?: (
    type: number,
    data: OrderSplit[],
    collectionType: number,
    collectionData: OrderCollection[]
  ) => void;
  total: string;
}

interface Option {
  label: string;
  value: string;
}

const defaultAdvisor = {
  advisorId: [],
  scale: "",
  editable: false,
};

function fuzzyQuery(list: any[], keyWord: string) {
  var arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].label.indexOf(keyWord) >= 0) {
      arr.push(list[i]);
    }
  }
  return arr;
}
const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let moneyKeyboardWrapProps: object | undefined;
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e: { preventDefault: () => any }) => e.preventDefault(),
  };
}

const StepSeven = ({ onCancel, onOk, total }: sevenProps) => {
  const [currentStaffDictionary, setCurrentStaffDictionary] = useState<
    Option[]
  >([]);
  const [splitForm, setSplitForm] = useState<OrderSplit[]>([
    {
      advisorType: "销售地业务员",
      splitData: [defaultAdvisor],
    },
    {
      advisorType: "服务地业务员",
      splitData: [defaultAdvisor],
    },
  ]);

  const collectionRef = useRef<any>();

  const [splitType, setSplitType] = useState<number>(0);
  const [staffDictionary, setStaffDictionary] = useState<Option[]>([]);

  // window.addEventListener("resize", function () {
  //   // 解决键盘弹起后遮挡输入框的问题
  //   if (
  //     document.activeElement!.tagName == "INPUT" ||
  //     document.activeElement!.tagName == "TEXTAREA"
  //   ) {
  //     window.setTimeout(function () {
  //       // @ts-ignore
  //       document.activeElement!.scrollIntoViewIfNeeded();
  //     }, 0);
  //   }
  // });

  useEffect(() => {
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=base_staff
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setStaffDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
          setCurrentStaffDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
    window.scrollTo(0, 0);
  }, []);

  const addAdvisor = useCallback(
    (index) => {
      const copy = JSON.parse(JSON.stringify(splitForm));
      copy[index].splitData.push(defaultAdvisor);
      setSplitForm(copy);
    },
    [splitForm]
  );

  const onSave = useCallback(
    (type, data: OrderSplit[]) => {
      const collectionData = collectionRef.current?.getData();
      if (!collectionData) return;
      const collectionType = collectionRef.current?.getType();
      if (type === 1) {
        let scaleArr: string[] = [];
        let sum: number = 0;
        data.forEach((item) => {
          const arr = item.splitData.map((children) => children.scale);
          scaleArr = scaleArr.concat(arr);
        });
        scaleArr.forEach((ele) => {
          sum += parseFloat(ele);
        });
        if (sum !== 100) {
          Toast.info("所有比例之和应为100", 1);
          return;
        }
      }
      onOk?.(type, data, collectionType, collectionData);
    },
    [onOk]
  );

  return (
    <>
      <NavBar
        className="orderNavBar"
        icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <StepSix ref={collectionRef} total={total} />
      <div className="mb100">
        <div style={{ lineHeight: "40px", padding: "0 20px" }}>订单拆分</div>
        <div style={{ background: "#f2f2f2", padding: "5px 20px 10px" }}>
          <SegmentedControl
            values={["不拆分", "拆分"]}
            selectedIndex={splitType}
            onChange={(e) => setSplitType(e.nativeEvent.selectedSegmentIndex)}
          />
        </div>
        {splitType === 1 && (
          <div>
            {splitForm.length > 0 &&
              splitForm.map((item, index) => (
                <List key={"service" + index}>
                  <Flex
                    justify="between"
                    style={{ background: "#f2f2f2", padding: "10px 20px" }}>
                    <Flex.Item>{item.advisorType}</Flex.Item>
                    <Flex.Item
                      style={{ textAlign: "right", color: "#169BD5" }}
                      onClick={() => {
                        let copy = JSON.parse(JSON.stringify(splitForm));
                        copy[index].splitData = copy[index].splitData.map(
                          (copyItem: any) => ({
                            ...copyItem,
                            editable: !copyItem.editable,
                          })
                        );
                        setSplitForm(copy);
                      }}>
                      {item.splitData[0].editable ? "完成" : "编辑"}
                    </Flex.Item>
                  </Flex>
                  {item.splitData.length > 0 &&
                    item.splitData.map((childrenItem, i) => (
                      <Fragment key={"parentService" + i}>
                        <Picker
                          data={currentStaffDictionary}
                          cols={1}
                          disabled={childrenItem.editable}
                          onOk={(val) => {
                            setCurrentStaffDictionary(staffDictionary);
                          }}
                          title={
                            <input
                              style={{
                                border: "1px solid #999",
                                borderRadius: 5,
                                width: "60%",
                              }}
                              onChange={(e) => {
                                const copy = JSON.parse(
                                  JSON.stringify(staffDictionary)
                                );
                                const newArr = fuzzyQuery(copy, e.target.value);
                                setCurrentStaffDictionary(newArr);
                              }}
                            />
                          }
                          value={childrenItem.advisorId}
                          onChange={(val: any) => {
                            let copy = JSON.parse(JSON.stringify(splitForm));
                            copy[index].splitData[i].advisorId = val;
                            setSplitForm(copy);
                          }}>
                          <List.Item arrow="horizontal">
                            <div
                              style={{ display: "flex", alignItems: "center" }}>
                              {childrenItem.editable && i > 0 && (
                                <Icon
                                  type="cross-circle-o"
                                  size="xxs"
                                  style={{ color: "#aaa", marginRight: 5 }}
                                  onClick={(e) => {
                                    let copy = JSON.parse(
                                      JSON.stringify(splitForm)
                                    );
                                    copy[index].splitData.splice(i, 1);
                                    setSplitForm(copy);
                                    e.stopPropagation();
                                  }}
                                />
                              )}
                              业务员
                            </div>
                          </List.Item>
                        </Picker>
                        <InputItem
                          placeholder="请输入"
                          extra={"%"}
                          type="money"
                          moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                          editable={!childrenItem.editable}
                          value={childrenItem.scale}
                          onChange={(val) => {
                            let copy = JSON.parse(JSON.stringify(splitForm));
                            copy[index].splitData[i].scale = formatRoundNumber(
                              val
                            );
                            setSplitForm(copy);
                          }}>
                          比例
                        </InputItem>
                      </Fragment>
                    ))}
                  {!item.splitData[0].editable && (
                    <>
                      <div className="space"></div>
                      <div
                        className="addShopBtn"
                        onClick={() => addAdvisor(index)}>
                        + 添加业务员
                      </div>
                      <div className="space"></div>
                    </>
                  )}
                </List>
              ))}
          </div>
        )}
      </div>

      <Flex style={bottomBtnStyle}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            上一步
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button type="primary" onClick={() => onSave?.(splitType, splitForm)}>
            提交
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default StepSeven;
